<template>
    <loader_page
        v-if="isLoadData"
        :key="'load_page'"
    />
</template>

<script>

import start_choice_rest from "../rest/StartChoiceRest.vue";
import menu_orders from "../menu/order/MenuOrders.vue";
import loaderPage from "../loader/LoaderPage.vue";
import Loader_page from "../loader/LoaderPage.vue";
import rest_select_list from "../rest/RestSelectList.vue";
import {createHelpers} from "vuex-map-fields";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

export default {
    name: "home_page",
    props: {},
    emits: [],
    components: {
        rest_select_list,
        Loader_page,
        menu_orders,
        start_choice_rest,
        loaderPage
    },
    mixins: [],
    data() {
        return {
            isLoadData: false,
            isLoadMenuMain: false,
            isLoadCountLocations: false,
        }
    },
    beforeMount() {
        this.$store.dispatch('user/GET_MENU_MAIN');
        this.$store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT', {actionName: 'updateMenuSelectLocationsCount'});
        EventBus.$on('update_menu_select_locations_count', this.updateMenuSelectLocationsCount);
        EventBus.$on('load_menu_main', this.loadMenuMain);
        this.isLoadData = true;
        this.isLoadMenuMain = true;
        this.isLoadCountLocations = true;
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenuMain);
        EventBus.$off('update_menu_select_locations_count', this.updateMenuSelectLocationsCount);
    },
    methods: {
        loadMenuMain() {
            this.isLoadMenuMain = false;
            if(!this.isLoadCountLocations){
                this.clickItemMenuMain();
            }
        },
        updateMenuSelectLocationsCount() {
            this.isLoadCountLocations = false;
            if(!this.isLoadMenuMain){
                this.clickItemMenuMain();
            }
        },
        clickItemMenuMain() {
            if (this.isSelectRestaurant) {
                const activeItem = this.menuMainItems.find(item => item.name === 'orders');
                if (activeItem !== undefined) {
                    this.$store.dispatch('user/CLICK_ITEM_MENU_MAIN', activeItem);
                }
                return;
            }
            const activeItem = this.menuMainItems.find(item => item.name === 'select_rest');
            if (activeItem !== undefined) {
                this.$store.dispatch('user/CLICK_ITEM_MENU_MAIN', activeItem);
            }
        }
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
            'menuMainItems'
        ]),
        ...mAggregators([
            'countAggregatorsSelectLocations'
        ]),
        isSelectRestaurant() {
            return this.countAggregatorsSelectLocations !== 0;
        },
    }
}
</script>
